const pageSizes = [10, 15, 20, 25, 50];

export default pageSizes;
